import { Space, Table } from 'antd';
import { CheckboxFilter } from 'components/Filters/CheckboxFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { RangePickerFilter } from 'components/Filters/RangePickerFilter';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import React from 'react';
import { formatDate } from 'utils';
import {
  sendingFrequency,
  sendingFrequencyList,
} from 'utils/handbooks/pushManagerHandbooks';

export const renderDate = (date, record) => {
  if (!date) return 'Каджый день';

  const { send_frequency } = record;

  if (send_frequency === 'daily') {
    return 'Каждый день';
  }

  if (send_frequency === 'weekly') {
    return `Каждый ${formatDate(date, 'dddd')} `;
  }

  if (send_frequency === 'monthly') {
    return `Каждый месяц ${formatDate(date, 'D')} числа`;
  }

  return formatDate(date);
};

function PushNotificationTable({
  items,
  loading,
  current,
  pageSize,
  filters = {},
  totalRows,
  onRowClick,
  onChange,
  onFilter,
}) {
  const { start_date, end_date, send_frequency } = filters;

  const columns = [
    {
      title: 'Наименование',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Сегмент',
      dataIndex: 'segments',
      key: 'segments',
      render: (segments) => (
        <Space wrap>
          {segments.map(({ id, title }) => (
            <div key={id}>{title}</div>
          ))}
        </Space>
      ),
    },
    {
      title: 'Условия',
      dataIndex: 'send_frequency',
      key: 'send_frequency',
      render: (value) => {
        if (!sendingFrequency[value]) return 'Разовое';
        return sendingFrequency[value];
      },
      filterDropdown: () => {
        return (
          <CheckboxFilter
            filter={send_frequency}
            filters={[
              { value: 'one_time', text: 'Разовое' },
              ...sendingFrequencyList,
            ]}
            onFilterChange={(send_frequency) => onFilter({ send_frequency })}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={send_frequency} />,
    },
    {
      title: 'Дата создания',
      dataIndex: 'created_date',
      key: 'created_date',
      render: (date) => (date ? formatDate(date) : '---'),
      filterDropdown: () => {
        return (
          <RangePickerFilter
            value={[start_date, end_date]}
            onFilterChange={([start, end]) => {
              onFilter({ start_date: start, end_date: end });
            }}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={start_date && end_date} />,
    },
    {
      title: 'Дата отправления ',
      dataIndex: 'date_send',
      key: 'date_send',
      render: renderDate,
    },
    {
      title: 'Дата окончания',
      dataIndex: 'active_until',
      key: 'active_until',
      render: (date) => (date ? formatDate(date) : '---'),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '1200px' }}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { PushNotificationTable };
